import {Item} from './Item'
import st from './Agent.module.scss'
import {splitData} from 'helpers'

export const WithoutSlider = ({ data })=> {
    const [top, bottom] = splitData(data, 3)

    return (
        <div className="wrapper">
            <div className={st.top}>
                {top?.map(person => <Item key={person.id} data={person} />)}
            </div>
            <div className={st.bottom}>
                {bottom?.map(person => <Item key={person.id} data={person} />)}
            </div>
        </div>
    )
}
